import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useVertical } from '../contexts/VerticalContext';
import IndustryRecommendedAddons from '../components/IndustryRecommendedAddons';
import WorkflowsScreen from '../components/WorkflowsScreen';
import WorkflowInbox from '../components/WorkflowInbox';
import WorkflowBuilderScreen from '../components/WorkflowBuilderScreen';
import WorkflowDelegations from '../components/WorkflowDelegations';
import { useDashboardTabRoute } from '../hooks/useDashboardTabRoute';
import { employeeAPI, attendanceAPI, fraudAPI, biometricAPI, workspaceAdminAPI, performanceAPI, departmentMasterAPI, leaveAPI } from '../services/api';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Textarea } from '../components/ui/textarea';
import { toast } from 'sonner';
import { getErrorMessage } from '../lib/utils';
import CameraCapture from '../components/CameraCapture';
import FraudAnalyticsDashboard from './FraudAnalyticsDashboard';
import GeofenceManagement from './GeofenceManagement';
import LeaveManagement from './LeaveManagement';
import LeaveTypesManagement from '../components/LeaveTypesManagement';
import LeaveSection from '../components/LeaveSection';
import PayrollManagement from '../components/PayrollManagement';
import AttendanceManagement from '../components/AttendanceManagement';
import BenefitsManagement from '../components/BenefitsManagement';
import OnboardingManagement from './OnboardingManagement';
import ReportsHub from './ReportsHub';
import AttendanceRuleConfig from '../components/AttendanceRuleConfig';
import RebrandingModule from '../components/RebrandingModule';
import { SelectField } from '../components/ui/select-field';
import * as OPT from '../lib/operatingModelOptions';
import DepartmentMasterScreen from '../components/DepartmentMasterScreen';
import TeamSection from '../components/TeamSection';
import HelpdeskModule from '../components/HelpdeskModule';
import PulseSurveysModule from '../components/PulseSurveysModule';
import ExecutiveAnalyticsDashboard from '../components/ExecutiveAnalyticsDashboard';
import WorkRequestModule from '../components/WorkRequestModule';
import ApprovalsInboxModule from '../components/ApprovalsInboxModule';
import GamificationModuleDeferred from '../components/GamificationModuleDeferred';
import AdminEmployeeProfilePage from './AdminEmployeeProfilePage';
import AdminEmployeeEditPage from './AdminEmployeeEditPage';
import AdminEmployeeCreatePage from './AdminEmployeeCreatePage';
import AdminMasterImportPage from './AdminMasterImportPage';
import AdminDepartmentsMasterPage from './AdminDepartmentsMasterPage';
import AdminSubDepartmentsMasterPage from './AdminSubDepartmentsMasterPage';
import AdminDesignationsMasterPage from './AdminDesignationsMasterPage';
import AdminMasterEntityPage from './AdminMasterEntityPage';
import AdminBenefitsPlansPage from './AdminBenefitsPlansPage';
import AdminSalaryStructuresPage from './AdminSalaryStructuresPage';
import AdminTaxSlabsPage from './AdminTaxSlabsPage';
import AdminAttendanceShiftConfigPage from './AdminAttendanceShiftConfigPage';
import AdminAttendanceShiftCreatePage from './AdminAttendanceShiftCreatePage';
import AdminAttendanceRulesOnlyPage from './AdminAttendanceRulesOnlyPage';
import AdminAttendanceRuleCrudPage from './AdminAttendanceRuleCrudPage';
import AdminGeofencePage from './AdminGeofencePage';
import AdminOnboardingChecklistsPage from './AdminOnboardingChecklistsPage';
import AdminEmployeeOnboardingWizardPage from './AdminEmployeeOnboardingWizardPage';
import TenantAICommandCenterPage from './TenantAICommandCenterPage';
import AICenterFeaturePage from './AICenterFeaturePage';
import AICenterSettingsPage from './AICenterSettingsPage';
import AIAssistant from '../components/AIAssistant';
import AIAssistantSettings from '../components/AIAssistantSettings';
import AIAgentBuilder from '../components/AIAgentBuilder';
import AIUsageDashboard from '../components/AIUsageDashboard';
import { ClickableKpiCard, KpiDetailPanel } from '../components/common/ClickableKpiCard';
import { TableExportActions } from '../components/ui/table-export-actions';
import { TableControls } from '../components/ui/table-controls';
import GrowthModule from '../components/GrowthModule';
import WorkplaceModule from '../components/WorkplaceModule';
import MyAccountModule from '../components/MyAccountModule';
import Layout from '../components/Layout';
import TenantOperatingModelPanel from '../components/TenantOperatingModelPanel';
import AssetManagementModule from '../components/AssetManagementModule';
import EsiModule from '../components/EsiModule';
import PfModule from '../components/PfModule';
import FinalSettlements from '../components/FinalSettlements';
import TaxFilings from '../components/TaxFilings';
import EducationFacultyManagement from '../components/EducationFacultyManagement';
import EducationCalendarManagement from '../components/EducationCalendarManagement';
import EducationTimetableManagement from '../components/EducationTimetableManagement';
import { EducationCoursesPage, EducationRoomsPage, EducationSchoolsPage, EducationDepartmentsPage } from '../components/EducationCatalog';
import EnterpriseSsoSettings from '../components/EnterpriseSsoSettings';
import SessionGovernanceModule from '../components/SessionGovernanceModule';
import PlanCatalogModule from '../components/PlanCatalogModule';
import { LegalEntitiesPage, BusinessUnitsPage } from '../components/OrgEntities';
import EquityManagement, { MyEquity } from '../components/EquityManagement';
import IntegrationsManagement from '../components/IntegrationsManagement';
import EducationContractsManagement from '../components/EducationContractsManagement';
import EducationAccreditationManagement from '../components/EducationAccreditationManagement';
import EducationResearchManagement from '../components/EducationResearchManagement';
import EducationGrievanceManagement from '../components/EducationGrievanceManagement';
import EducationStudentWorkerManagement from '../components/EducationStudentWorkerManagement';
import EducationAdjunctManagement from '../components/EducationAdjunctManagement';
import EducationIntegrationsManagement from '../components/EducationIntegrationsManagement';
import ProfileSection from '../components/ProfileSection';
import SubTenantCreationPanel from '../components/SubTenantCreationPanel';
import SubTenantsCombinedDashboard from '../components/SubTenantsCombinedDashboard';
import { 
  Users, UserPlus, Calendar, AlertTriangle, Fingerprint, Edit, Trash, 
  FileText, DollarSign, ClipboardList, BarChart3, Settings, LayoutDashboard, MapPin, User, ShieldCheck, LifeBuoy, Wand2, Save,
  TrendingUp, TrendingDown, UserCheck, UserX, Clock3, PlaneTakeoff, Activity, BrainCircuit, Trophy, Package, Building2, GraduationCap,
  CalendarDays, CalendarClock, FileSignature, Award, FlaskConical, ShieldAlert, UserCog, Plug, BookOpen, DoorOpen, School, Landmark, Boxes, Coins
} from 'lucide-react';
import { format, subDays } from 'date-fns';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import Swal from 'sweetalert2';
import { getAdminNavSchema, mapNavItemsWithIcons, filterAiAssistantNav } from '../lib/navigation';
import { filterNavByMenuAccess, filterNavByModuleAccess } from '../lib/planAccess';
import { hasAiAssistantAddon } from '../lib/aiDashboardAddons';
import { useTableControls } from '../hooks/useTableControls';
import { filterVisibleEmployees } from '../lib/employeeVisibility';
import HRLifecycleManagement from '../components/HRLifecycleManagement';
import HRActionCenter from '../components/HRActionCenter';
import HROperationsModule from '../components/HROperationsModule';
import ExitManagement from '../components/ExitManagement';
import ContractsManagement from '../components/ContractsManagement';
import DocumentTemplates from '../components/DocumentTemplates';
import TenantAccessControl from '../components/TenantAccessControl';
import ReportEngine from '../components/ReportEngine';
import {
  UpcomingBirthdays, UpcomingHolidays, MiniCalendar, RecentHires,
  WorkforceDistribution, DepartmentSummary,
} from '../components/dashboard/ExecutiveWidgets';
import { tooltipContentStyle, tooltipCursor, axisProps, gridProps } from '../lib/chartTheme';
import { StatCard } from '../components/common/StatCard';

import { useLocation, useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const { logout, user, exitProxy } = useAuth();
  const { term } = useVertical();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useDashboardTabRoute('/admin', 'dashboard');
  const isTenantAdminRole = ['workspace_admin', 'hr_admin'].includes(String(user?.role || '').toLowerCase());
  const canAccessChildTenantPage = Boolean(isTenantAdminRole && !user?.isSuperadmin && !user?.parentTenantId);

  // Card click handlers
  const handleCardClick = (destination) => {
    switch (destination) {
      case '/employees':
      case '/employees?filter=enrolled':
        setActiveTab('employees');
        break;
      case '/fraud-analytics':
        setActiveTab('fraud');
        break;
      case '/geofence-management':
        setActiveTab('geofence');
        navigate('/admin/geofence');
        break;
      default:
        setActiveTab('dashboard');
        break;
    }
  };

  const openDashboardCardDetail = (detail) => {
    setDashboardCardDetail(detail);
  };
  const [employees, setEmployees] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [approvedLeaves, setApprovedLeaves] = useState([]);
  const [holidayDates, setHolidayDates] = useState([]);
  const [fraudAlerts, setFraudAlerts] = useState([]);
  const [showEnrollment, setShowEnrollment] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [workspaceSettings, setWorkspaceSettings] = useState({
    display_name: '',
    legal_name: '',
    support_email: '',
    support_phone: '',
    website_url: '',
    address: '',
    timezone: 'UTC',
    currency_code: 'INR',
    payroll_note: '',
  });
  const [workspaceSetup, setWorkspaceSetup] = useState(null);
  const [auditLogs, setAuditLogs] = useState([]);
  const [workspaceLoading, setWorkspaceLoading] = useState(false);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  // Chart Data State
  const [deptData, setDeptData] = useState([]);
  const [attTrend, setAttTrend] = useState([]);
  const [attendanceTrendMode, setAttendanceTrendMode] = useState('daily');
  const [employeeSearch, setEmployeeSearch] = useState('');
  const [employeeStatusFilter, setEmployeeStatusFilter] = useState('all');
  const [employeeDepartmentFilter, setEmployeeDepartmentFilter] = useState('all');
  const [employeeSubDepartmentFilter, setEmployeeSubDepartmentFilter] = useState('all');
  const [employeeOfficeFilter, setEmployeeOfficeFilter] = useState('all');

  const COLORS = [
    'hsl(var(--chart-1))', 
    'hsl(var(--chart-2))', 
    'hsl(var(--chart-3))', 
    'hsl(var(--chart-4))', 
    'hsl(var(--chart-5))', 
    'hsl(var(--primary))'
  ];

  const [performanceOverview, setPerformanceOverview] = useState(null);
  const [selectedPerformerDetail, setSelectedPerformerDetail] = useState(null);
  const performerHistoryTable = useTableControls(selectedPerformerDetail?.history || [], {
    initialSortKey: 'year',
    initialSortDirection: 'desc',
  });
  const [showPerformerDetail, setShowPerformerDetail] = useState(false);
  const [dashboardCardDetail, setDashboardCardDetail] = useState(null);
  const [kpiFormLoading, setKpiFormLoading] = useState(false);
  const [kpiFormSaving, setKpiFormSaving] = useState(false);
  const [kpiForm, setKpiForm] = useState({
    employee_id: '',
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    goal_achievement: '0',
    quality_score: '0',
    time_management_score: '0',
    feedback_360_score: '0',
    engagement_score: '0',
  });

  const navItems = useMemo(
    () => {
      const includeReturnToSuperadmin = Boolean(user?.isSuperadmin || user?.canReturnToSuperadmin);
      const navSchema = getAdminNavSchema({ includeReturnToSuperadmin });
      const moduleFiltered = filterNavByModuleAccess(navSchema, user?.moduleAccess, user?.isSuperadmin);
      const menuFiltered = filterNavByMenuAccess(moduleFiltered, user?.menuAccess, user?.menuDenied);
      const filteredSchema = filterAiAssistantNav(menuFiltered, hasAiAssistantAddon(user));
      const nextSchema = canAccessChildTenantPage
        ? [
          ...filteredSchema,
          // One group rather than two adjacent top-level entries: a supertenant
          // browses the list and adds to it in the same sitting, and the pair
          // read as a heading and its action rather than two unrelated menus.
          {
            id: 'subtenant-hub',
            label: 'Sub-Tenants',
            iconKey: 'workspace',
            subItems: [
              { id: 'subtenants', label: 'All Sub-Tenants' },
              { id: 'subtenant-create', label: 'Add Sub-Tenant' },
            ],
          },
        ]
        : filteredSchema;
      return mapNavItemsWithIcons(
        nextSchema,
        {
          dashboard: LayoutDashboard,
          ai: BrainCircuit,
          employees: Users,
          actionCenter: ClipboardList,
          onboarding: ClipboardList,
          attendance: Calendar,
          leaves: FileText,
          finance: DollarSign,
          team: User,
          profile: User,
          helpdesk: LifeBuoy,
          gamification: Trophy,
          assets: Package,
          benefits: FileText,
          policies: Settings,
          reports: BarChart3,
          fraud: AlertTriangle,
          geofence: MapPin,
          workspace: ShieldCheck,
          sso: Fingerprint,
          legalEntity: Landmark,
          businessUnit: Boxes,
          equity: Coins,
          integrations: Plug,
          master: Settings,
          academic: GraduationCap,
          eduSchools: School,
          eduDepartments: Building2,
          eduCalendar: CalendarDays,
          eduTimetable: CalendarClock,
          eduCourses: BookOpen,
          eduRooms: DoorOpen,
          eduContracts: FileSignature,
          eduAccreditation: Award,
          eduResearch: FlaskConical,
          eduGrievance: ShieldAlert,
          eduStudentWorker: Users,
          eduAdjunct: UserCog,
          eduIntegrations: Plug,
          profile: User,
        }
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally keyed on the specific user.* fields used
    [canAccessChildTenantPage, user?.isSuperadmin, user?.canReturnToSuperadmin, user?.moduleAccess, user?.menuAccess, user?.menuDenied]
  );
  const parentTenantDisplayName = (user?.parentTenantName || user?.parentTenantSlug || '').trim();
  const currentTenantDisplayName = (user?.tenantName || user?.tenantSlug || 'Tenant').trim();
  const tenantDisplayName = parentTenantDisplayName || currentTenantDisplayName;
  const subTenantDisplayName = parentTenantDisplayName && currentTenantDisplayName !== tenantDisplayName
    ? currentTenantDisplayName
    : '';
  const planDisplayName = (user?.subscriptionPlanName || user?.subscriptionPlanCode || 'Unassigned').trim();

  useEffect(() => {
    const isDedicatedAdminRoute = /^\/admin\/(employees\/[^/]+\/(profile|edit)|employees\/new|onboarding-wizard\/[^/]+|import\/[^/]+|master\/(departments|subdepartments|designations)(\/new|\/[^/]+\/(view|edit|delete))?|master\/subdepartments-designations|rules-shifts\/create|attendance-rules(\/new|\/[^/]+\/(view|edit|delete))?|geofence)$/.test(
      location.pathname
    );
    if (isDedicatedAdminRoute) {
      return;
    }

    const allowedIds = new Set(navItems.flatMap((item) => [item.id, ...(item.subItems || []).map((sub) => sub.id)]));
    if (allowedIds.size > 0 && !allowedIds.has(activeTab)) {
      setActiveTab(navItems[0]?.id || 'dashboard');
    }
  }, [navItems, activeTab, setActiveTab, location.pathname]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount; fetchData is stable
  }, []);

  const fetchData = async () => {
    try {
      const currentYear = new Date().getFullYear();
      const previousYear = currentYear - 1;
      const [empRes, attRes, fraudRes, perfRes, deptRes, leaveRes, holidaysCurrentRes, holidaysPreviousRes] = await Promise.all([
        employeeAPI.list(),
        attendanceAPI.getAllRecords(),
        fraudAPI.getAlerts(),
        performanceAPI.getAdminOverview({ limit: 5 }),
        departmentMasterAPI.listOptions().catch(() => ({ data: [] })),
        leaveAPI.list({ status: 'approved' }).catch(() => ({ data: [] })),
        leaveAPI.getHolidays(currentYear).catch(() => ({ data: [] })),
        leaveAPI.getHolidays(previousYear).catch(() => ({ data: [] })),
      ]);
      setEmployees(filterVisibleEmployees(empRes.data, user));
      setAttendance(attRes.data);
      setApprovedLeaves(Array.isArray(leaveRes.data) ? leaveRes.data : []);
      setHolidayDates([
        ...(Array.isArray(holidaysCurrentRes.data) ? holidaysCurrentRes.data : []),
        ...(Array.isArray(holidaysPreviousRes.data) ? holidaysPreviousRes.data : []),
      ]);
      setFraudAlerts(fraudRes.data);
      setPerformanceOverview(perfRes.data || null);
      setDepartmentOptions(deptRes.data || []);

      // Process Department Data
      const depts = {};
      empRes.data.forEach(e => {
        const d = e.department || 'Unassigned';
        depts[d] = (depts[d] || 0) + 1;
      });
      setDeptData(Object.keys(depts).map(key => ({ name: key, value: depts[key] })));

      // Process Attendance Trend (Last 7 days)
      const trend = [];
      for (let i = 6; i >= 0; i--) {
        const date = subDays(new Date(), i);
        const dateStr = format(date, 'yyyy-MM-dd');
        const count = attRes.data.filter(a => 
          new Date(a.check_in_time).toISOString().startsWith(dateStr)
        ).length;
        trend.push({ name: format(date, 'EEE'), count });
      }
      setAttTrend(trend);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const openPerformerDetail = async (employeeId) => {
    try {
      const month = performanceOverview?.month || new Date().getMonth() + 1;
      const year = performanceOverview?.year || new Date().getFullYear();
      const response = await performanceAPI.getEmployeeDetail(employeeId, { month, year });
      setSelectedPerformerDetail(response.data || null);
      setShowPerformerDetail(true);
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to load performance detail'));
    }
  };

  const updateKpiFormField = (field, value) => {
    setKpiForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleAutoCalculateKpi = async () => {
    if (!kpiForm.employee_id) {
      toast.error('Select an employee first');
      return;
    }
    try {
      setKpiFormLoading(true);
      const response = await performanceAPI.getEmployeeDetail(kpiForm.employee_id, {
        month: Number(kpiForm.month),
        year: Number(kpiForm.year),
      });
      const params = response.data?.current?.key_parameters || [];
      const byKey = Object.fromEntries(params.map((item) => [item.key, item]));
      setKpiForm((prev) => ({
        ...prev,
        goal_achievement: String(byKey.goal_achievement?.score ?? 0),
        quality_score: String(byKey.quality?.score ?? 0),
        time_management_score: String(byKey.time_management?.score ?? 0),
        feedback_360_score: String(byKey.feedback_360?.score ?? 0),
        engagement_score: String(byKey.engagement?.score ?? 0),
      }));
      toast.success('KPI values auto-calculated from attendance/tasks/feedback data');
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to auto-calculate KPI values'));
    } finally {
      setKpiFormLoading(false);
    }
  };

  const handleSaveKpiValues = async () => {
    if (!kpiForm.employee_id) {
      toast.error('Select an employee first');
      return;
    }
    const toScore = (value) => {
      const n = Number(value);
      if (!Number.isFinite(n)) return 0;
      return Math.max(0, Math.min(100, n));
    };
    try {
      setKpiFormSaving(true);
      await performanceAPI.upsertKpi({
        employee_id: kpiForm.employee_id,
        month: Number(kpiForm.month),
        year: Number(kpiForm.year),
        kpi_goal_target: 100,
        kpi_goal_achieved: toScore(kpiForm.goal_achievement),
        quality_score: toScore(kpiForm.quality_score),
        time_management_score: toScore(kpiForm.time_management_score),
        feedback_360_score: toScore(kpiForm.feedback_360_score),
        engagement_score: toScore(kpiForm.engagement_score),
      });
      toast.success('KPI values saved successfully');
      fetchData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to save KPI values'));
    } finally {
      setKpiFormSaving(false);
    }
  };

  const loadWorkspaceData = async () => {
    try {
      setWorkspaceLoading(true);
      const [settingsRes, setupRes, auditRes] = await Promise.all([
        workspaceAdminAPI.getSettings(),
        workspaceAdminAPI.getSetupStatus(),
        workspaceAdminAPI.getAuditLogs({ limit: 20 }),
      ]);

      setWorkspaceSettings({
        display_name: settingsRes.data.display_name || '',
        legal_name: settingsRes.data.legal_name || '',
        support_email: settingsRes.data.support_email || '',
        support_phone: settingsRes.data.support_phone || '',
        website_url: settingsRes.data.website_url || '',
        address: settingsRes.data.address || '',
        timezone: settingsRes.data.timezone || 'UTC',
        currency_code: settingsRes.data.currency_code || 'INR',
        payroll_note: settingsRes.data.payroll_note || '',
      });
      setWorkspaceSetup(setupRes.data);
      setAuditLogs(auditRes.data || []);
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to load workspace settings'));
    } finally {
      setWorkspaceLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'workspace') {
      loadWorkspaceData();
    }
  }, [activeTab]);

  const handleBiometricEnrollment = async (base64Image) => {
    setShowEnrollment(false);
    try {
      await biometricAPI.enroll({
        employee_id: selectedEmployee.employee_id,
        face_image_base64: base64Image,
        sample_number: 1,
        consent_confirmed: true,
      });
      toast.success('Biometric enrollment successful');
      fetchData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Enrollment failed'));
    }
  };

  const openEmployeeProfilePage = (employeeId) => {
    navigate(`/admin/employees/${employeeId}/profile`);
  };

  const openEmployeeEditPage = (employeeId) => {
    navigate(`/admin/employees/${employeeId}/edit`);
  };

  const openEmployeeCreatePage = () => {
    navigate('/admin/employees/new');
  };

  const openImportPage = (masterType) => {
    navigate(`/admin/import/${masterType}`);
  };

  const handleSyncEmployeeDepartmentMapping = async () => {
    try {
      const previewRes = await employeeAPI.previewSyncDepartmentMapping();
      const preview = previewRes.data || {};
      const changes = preview.changes || [];
      if (changes.length === 0) {
        toast.success('No employee department mapping changes required');
        return;
      }

      const esc = (value) => String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const rowsHtml = changes
        .slice(0, 120)
        .map((row) => `
          <tr>
            <td style="padding:6px;border-bottom:1px solid #eee;">${esc(row.employee_id)}</td>
            <td style="padding:6px;border-bottom:1px solid #eee;">${esc(row.employee_name)}</td>
            <td style="padding:6px;border-bottom:1px solid #eee;">${esc(row.current_department || '-')} / ${esc(row.current_sub_department || '-')}</td>
            <td style="padding:6px;border-bottom:1px solid #eee;">${esc(row.mapped_department || '-')} / ${esc(row.mapped_sub_department || '-')}</td>
            <td style="padding:6px;border-bottom:1px solid #eee;">${esc(row.current_designation || '-')}</td>
            <td style="padding:6px;border-bottom:1px solid #eee;">${esc(row.mapped_designation || '-')}</td>
            <td style="padding:6px;border-bottom:1px solid #eee;font-weight:600;">${esc(row.action)}</td>
          </tr>
        `)
        .join('');

      const result = await Swal.fire({
        title: 'Preview Department Mapping Sync',
        html: `
          <div style="text-align:left;margin-bottom:8px;">
            <div><strong>Total:</strong> ${preview.total_employees || 0}</div>
            <div><strong>Will Update:</strong> ${preview.updated || 0}</div>
            <div><strong>Will Clear:</strong> ${preview.cleared || 0}</div>
            <div><strong>Unchanged:</strong> ${preview.unchanged || 0}</div>
          </div>
          <div style="max-height:320px;overflow:auto;border:1px solid #e5e7eb;border-radius:8px;">
            <table style="width:100%;border-collapse:collapse;font-size:12px;">
              <thead style="position:sticky;top:0;background:#f8fafc;">
                <tr>
                  <th style="text-align:left;padding:6px;border-bottom:1px solid #e5e7eb;">Employee ID</th>
                  <th style="text-align:left;padding:6px;border-bottom:1px solid #e5e7eb;">Name</th>
                  <th style="text-align:left;padding:6px;border-bottom:1px solid #e5e7eb;">Current</th>
                  <th style="text-align:left;padding:6px;border-bottom:1px solid #e5e7eb;">Mapped</th>
                  <th style="text-align:left;padding:6px;border-bottom:1px solid #e5e7eb;">Current Designation</th>
                  <th style="text-align:left;padding:6px;border-bottom:1px solid #e5e7eb;">Mapped Designation</th>
                  <th style="text-align:left;padding:6px;border-bottom:1px solid #e5e7eb;">Action</th>
                </tr>
              </thead>
              <tbody>${rowsHtml}</tbody>
            </table>
          </div>
          ${changes.length > 120 ? `<div style="margin-top:6px;font-size:12px;color:#64748b;">Showing first 120 of ${changes.length} changes.</div>` : ''}
        `,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Apply Sync',
        cancelButtonText: 'Cancel',
        confirmButtonColor: 'hsl(var(--primary))',
        width: 1000,
      });

      if (!result.isConfirmed) return;

      const applyRes = await employeeAPI.syncDepartmentMapping();
      const data = applyRes.data || {};
      toast.success(`Synced mapping: ${data.updated || 0} updated, ${data.unchanged || 0} unchanged, ${data.cleared || 0} cleared`);
      await fetchData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to sync employee department mapping'));
    }
  };

  const handleDeleteEmployee = async (employeeId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'hsl(var(--primary))',
      cancelButtonColor: 'hsl(var(--destructive))',
      confirmButtonText: 'Yes, deactivate!'
    });

    if (result.isConfirmed) {
      try {
        await employeeAPI.delete(employeeId);
        Swal.fire(
          'Deactivated!',
          'Employee has been deactivated.',
          'success'
        );
        fetchData();
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: getErrorMessage(error, 'Failed to delete employee'),
          confirmButtonColor: 'hsl(var(--primary))'
        });
      }
    }
  };

  const handleSaveWorkspace = async (markSetupComplete = false) => {
    try {
      const normalizeOptional = (value) => {
        if (value === null || value === undefined) return null;
        if (typeof value !== 'string') return value;
        const trimmed = value.trim();
        return trimmed.length === 0 ? null : trimmed;
      };
      const payload = {
        display_name: (workspaceSettings.display_name || '').trim(),
        legal_name: normalizeOptional(workspaceSettings.legal_name),
        support_email: normalizeOptional(workspaceSettings.support_email),
        support_phone: normalizeOptional(workspaceSettings.support_phone),
        website_url: normalizeOptional(workspaceSettings.website_url),
        address: normalizeOptional(workspaceSettings.address),
        timezone: (workspaceSettings.timezone || 'UTC').trim(),
        currency_code: (workspaceSettings.currency_code || 'INR').toUpperCase(),
        payroll_note: normalizeOptional(workspaceSettings.payroll_note),
        mark_setup_complete: markSetupComplete,
      };
      await workspaceAdminAPI.updateSettings(payload);
      toast.success(markSetupComplete ? 'Workspace setup completed' : 'Workspace settings updated');
      loadWorkspaceData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to save workspace settings'));
    }
  };

  const handleSeedWorkspaceDefaults = async () => {
    try {
      await workspaceAdminAPI.seedDefaults();
      toast.success('Workspace defaults seeded successfully');
      loadWorkspaceData();
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to seed workspace defaults'));
    }
  };

  const stats = {
    totalEmployees: employees.length,
    enrolledEmployees: employees.filter(e => e.biometric_enrolled).length,
    todayAttendance: attendance.filter(a => 
      new Date(a.check_in_time).toDateString() === new Date().toDateString()
    ).length,
    activeFraudAlerts: fraudAlerts.filter(f => !f.is_resolved).length,
  };

  const attendanceSignals = useMemo(() => {
    const activeEmployeeCount = employees.filter((e) => e.is_active !== false).length || employees.length;
    const dayKey = (value) => {
      try {
        return format(new Date(value), 'yyyy-MM-dd');
      } catch (error) {
        return null;
      }
    };
    const leaveOnDate = (targetDate) => {
      const dayStart = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate(), 0, 0, 0, 0);
      const dayEnd = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate(), 23, 59, 59, 999);
      const ids = new Set();
      approvedLeaves.forEach((row) => {
        const start = row?.start_date ? new Date(row.start_date) : null;
        const end = row?.end_date ? new Date(row.end_date) : null;
        if (!start || !end || !row?.employee_id) return;
        if (start <= dayEnd && end >= dayStart) {
          ids.add(row.employee_id);
        }
      });
      return ids;
    };

    const holidayKeySet = new Set(
      holidayDates
        .map((h) => h?.date || h?.holiday_date || null)
        .filter(Boolean)
        .map((value) => {
          try {
            return format(new Date(value), 'yyyy-MM-dd');
          } catch (error) {
            return null;
          }
        })
        .filter(Boolean)
    );

    const isNonWorkingDay = (targetDate) => {
      const weekDay = targetDate.getDay(); // 0 = Sunday, 6 = Saturday
      if (weekDay === 0 || weekDay === 6) return true;
      const dateKey = format(targetDate, 'yyyy-MM-dd');
      return holidayKeySet.has(dateKey);
    };

    const buildSnapshot = (targetDate) => {
      const key = format(targetDate, 'yyyy-MM-dd');
      const sameDayRows = attendance.filter((row) => dayKey(row.check_in_time) === key);
      const leaveEmployeeIds = leaveOnDate(targetDate);
      const presentEmployeeIds = new Set(
        sameDayRows
          .map((row) => row.employee_id)
          .filter((id) => id && !leaveEmployeeIds.has(id))
      );
      const lateEmployeeIds = new Set(
        sameDayRows
          .filter((row) => String(row.status || '').toLowerCase().includes('late'))
          .map((row) => row.employee_id)
          .filter((id) => id && !leaveEmployeeIds.has(id))
      );
      const present = presentEmployeeIds.size;
      const onLeave = leaveEmployeeIds.size;
      const late = lateEmployeeIds.size;
      const absent = isNonWorkingDay(targetDate) ? 0 : Math.max(activeEmployeeCount - present - onLeave, 0);
      return { present, absent, late, onLeave };
    };

    const today = buildSnapshot(new Date());
    const yesterday = buildSnapshot(subDays(new Date(), 1));
    const pct = (current, previous) => {
      if (!previous) return current > 0 ? 100 : 0;
      return ((current - previous) / Math.abs(previous)) * 100;
    };

    return [
      {
        key: 'present',
        label: 'Present Today',
        value: today.present,
        deltaPct: pct(today.present, yesterday.present),
        icon: UserCheck,
      },
      {
        key: 'absent',
        label: 'Absent',
        value: today.absent,
        deltaPct: pct(today.absent, yesterday.absent),
        icon: UserX,
      },
      {
        key: 'late',
        label: 'Late',
        value: today.late,
        deltaPct: pct(today.late, yesterday.late),
        icon: Clock3,
      },
      {
        key: 'onLeave',
        label: 'On Leave',
        value: today.onLeave,
        deltaPct: pct(today.onLeave, yesterday.onLeave),
        icon: PlaneTakeoff,
      },
    ];
  }, [attendance, employees, approvedLeaves, holidayDates]);

  const attendanceTrendData = useMemo(() => {
    const dayKey = (value) => {
      try {
        return format(new Date(value), 'yyyy-MM-dd');
      } catch (error) {
        return null;
      }
    };
    const presentByDate = new Map();
    attendance.forEach((row) => {
      const key = dayKey(row.check_in_time);
      if (!key || !row.employee_id) return;
      if (!presentByDate.has(key)) {
        presentByDate.set(key, new Set());
      }
      presentByDate.get(key).add(row.employee_id);
    });
    const getCount = (dateObj) => {
      const key = format(dateObj, 'yyyy-MM-dd');
      return presentByDate.get(key)?.size || 0;
    };

    if (attendanceTrendMode === 'daily') {
      return Array.from({ length: 14 }, (_, idx) => {
        const date = subDays(new Date(), 13 - idx);
        return {
          label: format(date, 'dd MMM'),
          value: getCount(date),
        };
      });
    }
    if (attendanceTrendMode === 'weekly') {
      return Array.from({ length: 8 }, (_, idx) => {
        const endDate = subDays(new Date(), (7 - idx) * 7);
        const startDate = subDays(endDate, 6);
        let total = 0;
        for (let offset = 0; offset < 7; offset += 1) {
          total += getCount(subDays(endDate, offset));
        }
        return {
          label: `${format(startDate, 'dd MMM')} - ${format(endDate, 'dd MMM')}`,
          value: total,
        };
      });
    }
    return Array.from({ length: 6 }, (_, idx) => {
      const date = new Date();
      date.setMonth(date.getMonth() - (5 - idx));
      const month = date.getMonth();
      const year = date.getFullYear();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      let total = 0;
      for (let day = 1; day <= daysInMonth; day += 1) {
        total += getCount(new Date(year, month, day));
      }
      return {
        label: format(new Date(year, month, 1), 'MMM yyyy'),
        value: total,
      };
    });
  }, [attendance, attendanceTrendMode]);

  const employeeNameById = useMemo(
    () =>
      Object.fromEntries(
        employees.map((emp) => [emp.employee_id, `${emp.first_name || ''} ${emp.last_name || ''}`.trim() || emp.employee_id])
      ),
    [employees]
  );

  const employeeOfficeOptions = useMemo(() => {
    const seen = new Map();
    (employees || []).forEach((emp) => {
      const name = String(emp.location || '').trim();
      if (name) seen.set(name.toLowerCase(), name);
    });
    return [...seen.values()].sort((a, b) => a.localeCompare(b));
  }, [employees]);

  const employeeUnassignedOfficeCount = useMemo(
    () => (employees || []).filter((emp) => !String(emp.location || '').trim()).length,
    [employees]
  );

  const employeeDepartmentOptions = useMemo(
    () => (departmentOptions || []).map((row) => row.name).filter(Boolean).sort((a, b) => a.localeCompare(b)),
    [departmentOptions]
  );

  const selectedDepartmentMaster = useMemo(
    () => (departmentOptions || []).find((row) => row.name === employeeDepartmentFilter),
    [departmentOptions, employeeDepartmentFilter]
  );

  const employeeSubDepartmentOptions = useMemo(
    () => (selectedDepartmentMaster?.sub_departments || []).slice().sort((a, b) => a.localeCompare(b)),
    [selectedDepartmentMaster]
  );

  const getWorkAnniversaryLabel = (dateOfJoining) => {
    if (!dateOfJoining) return 'N/A';
    const joinDate = new Date(dateOfJoining);
    if (Number.isNaN(joinDate.getTime())) return 'N/A';
    const today = new Date();
    const years = Math.max(today.getFullYear() - joinDate.getFullYear(), 0);
    const monthDay = format(joinDate, 'dd MMM');
    return `${monthDay}${years > 0 ? ` (${years} yr${years > 1 ? 's' : ''})` : ''}`;
  };

  const adminActivityFeed = useMemo(() => {

    const attendanceEvents = attendance
      .filter((row) => row.check_in_time)
      .map((row) => ({
        at: new Date(row.check_in_time),
        message: `${employeeNameById[row.employee_id] || row.employee_id || 'Employee'} marked ${String(row.status || 'present').toLowerCase()}`,
      }));

    const approvedLeaveEvents = approvedLeaves
      .filter((row) => row?.updated_at || row?.created_at)
      .map((row) => ({
        at: new Date(row.updated_at || row.created_at),
        message: `Leave approved for ${employeeNameById[row.employee_id] || row.employee_id || 'employee'}`,
      }));

    const auditEvents = auditLogs.map((event) => {
      const action = String(event.action || '').toLowerCase();
      let message = `${event.action || 'Activity'} ${event.target ? `for ${event.target}` : ''}`.trim();
      if (action.includes('leave') && action.includes('approve')) {
        message = `Leave approved for ${event.target || 'employee'}`;
      } else if (action.includes('leave') && action.includes('reject')) {
        message = `Leave rejected for ${event.target || 'employee'}`;
      }
      return {
        at: event.created_at ? new Date(event.created_at) : new Date(),
        message,
      };
    });

    return [...attendanceEvents, ...approvedLeaveEvents, ...auditEvents]
      .sort((a, b) => b.at - a.at)
      .slice(0, 10);
  }, [attendance, approvedLeaves, auditLogs, employeeNameById]);

  const filteredEmployees = useMemo(() => {
    const keyword = employeeSearch.trim().toLowerCase();
    const bySearch = employees.filter((emp) => {
      if (!keyword) return true;
      const haystack = [
        emp.first_name,
        emp.last_name,
        emp.employee_id,
        emp.department,
        emp.sub_department,
        emp.designation,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return haystack.includes(keyword);
    });
    const byStatus = bySearch.filter((emp) => {
      if (employeeStatusFilter === 'all') return true;
      if (employeeStatusFilter === 'active') return emp.is_active;
      if (employeeStatusFilter === 'inactive') return !emp.is_active;
      if (employeeStatusFilter === 'enrolled') return emp.biometric_enrolled;
      if (employeeStatusFilter === 'not_enrolled') return !emp.biometric_enrolled;
      return true;
    });
    const byDepartment = byStatus.filter((emp) => {
      if (employeeDepartmentFilter === 'all') return true;
      return (emp.department || 'N/A') === employeeDepartmentFilter;
    });
    const bySubDepartment = byDepartment.filter((emp) => {
      if (employeeSubDepartmentFilter === 'all') return true;
      return (emp.sub_department || 'N/A') === employeeSubDepartmentFilter;
    });
    const byOffice = bySubDepartment.filter((emp) => {
      if (employeeOfficeFilter === 'all') return true;
      const office = String(emp.location || '').trim();
      // "Unassigned" is offered explicitly rather than folded into All: people
      // with no office recorded are the ones an admin most needs to find.
      if (employeeOfficeFilter === '__unassigned__') return !office;
      return office.toLowerCase() === employeeOfficeFilter.toLowerCase();
    });
    return byOffice.sort((a, b) =>
      `${a.first_name || ''} ${a.last_name || ''}`.localeCompare(`${b.first_name || ''} ${b.last_name || ''}`)
    );
  }, [employees, employeeSearch, employeeStatusFilter, employeeDepartmentFilter, employeeSubDepartmentFilter, employeeOfficeFilter]);

  const employeeExportColumns = useMemo(
    () => [
      { label: 'Employee ID', accessor: (row) => row.employee_id },
      { label: 'First Name', accessor: (row) => row.first_name },
      { label: 'Last Name', accessor: (row) => row.last_name },
      { label: 'Department', accessor: (row) => row.department || '' },
      { label: 'Sub Department', accessor: (row) => row.sub_department || '' },
      { label: 'Designation', accessor: (row) => row.designation || '' },
      { label: 'Reporting Manager', accessor: (row) => employeeNameById[row.reporting_manager_id] || row.reporting_manager_id || '' },
      { label: 'Work Anniversary', accessor: (row) => getWorkAnniversaryLabel(row.date_of_joining) },
      { label: 'Phone', accessor: (row) => row.phone || '' },
      { label: 'Work Email', accessor: (row) => row.email || '' },
      { label: 'Employment Status', accessor: (row) => row.employment_status || '' },
      { label: 'Active', accessor: (row) => (row.is_active ? 'Yes' : 'No') },
      { label: 'Biometric Enrolled', accessor: (row) => (row.biometric_enrolled ? 'Yes' : 'No') },
    ],
    [employeeNameById]
  );

  const enrollmentData = [
    { name: 'Enrolled', value: stats.enrolledEmployees },
    { name: 'Pending', value: Math.max(stats.totalEmployees - stats.enrolledEmployees, 0) },
  ];

  const activeEmployeesCount = useMemo(
    () => employees.filter((employee) => employee.is_active !== false).length,
    [employees]
  );

  const inactiveEmployeesCount = Math.max(employees.length - activeEmployeesCount, 0);
  const pendingEnrollmentCount = Math.max(employees.length - stats.enrolledEmployees, 0);
  const attendanceRateToday = employees.length > 0 ? ((stats.todayAttendance / employees.length) * 100) : 0;
  const unresolvedFraudCount = fraudAlerts.filter((alert) => !alert.is_resolved).length;
  const todayOnLeaveCount = attendanceSignals.find((signal) => signal.key === 'onLeave')?.value || 0;

  const roleDashboardMeta = useMemo(() => {
    if (user?.role === 'workspace_admin') {
      return {
        title: subTenantDisplayName ? 'Sub-Tenant Command Center' : 'Tenant Command Center',
        subtitle: subTenantDisplayName
          ? `Monitor workforce, compliance, and daily operations for ${tenantDisplayName} / ${subTenantDisplayName}.`
          : `Monitor workforce, compliance, and daily operations for ${tenantDisplayName}.`,
        badge: subTenantDisplayName ? 'Connected to Parent Tenant' : 'Tenant Workspace',
        highlight: subTenantDisplayName ? `Sub-Tenant: ${subTenantDisplayName}` : `${planDisplayName} plan`,
      };
    }
    if (user?.role === 'hr_admin') {
      return {
        title: 'HR Admin Command Center',
        subtitle: subTenantDisplayName
          ? `Track people operations, approvals, and execution signals for ${tenantDisplayName} / ${subTenantDisplayName}.`
          : `Track people operations, approvals, and execution signals for ${tenantDisplayName}.`,
        badge: subTenantDisplayName ? 'Connected to Parent Tenant' : 'HR Administration',
        highlight: subTenantDisplayName ? `Sub-Tenant: ${subTenantDisplayName}` : `${planDisplayName} plan`,
      };
    }
    return {
      title: 'Admin Command Center',
      subtitle: subTenantDisplayName
        ? `Run attendance, onboarding, compliance, and employee operations for ${tenantDisplayName} / ${subTenantDisplayName}.`
        : `Run attendance, onboarding, compliance, and employee operations for ${tenantDisplayName}.`,
      badge: subTenantDisplayName ? 'Connected to Parent Tenant' : 'Operations Control',
      highlight: subTenantDisplayName ? `Sub-Tenant: ${subTenantDisplayName}` : `${planDisplayName} plan`,
    };
  }, [planDisplayName, subTenantDisplayName, tenantDisplayName, user?.role]);

  const adminPriorityItems = useMemo(
    () => [
      {
        label: 'Unresolved fraud alerts',
        value: unresolvedFraudCount,
        tone: unresolvedFraudCount > 0 ? 'text-rose-600' : 'text-emerald-600',
        tab: 'fraud',
      },
      {
        label: 'Employees pending biometric enrollment',
        value: pendingEnrollmentCount,
        tone: pendingEnrollmentCount > 0 ? 'text-amber-600' : 'text-emerald-600',
        tab: 'employees',
      },
      {
        label: 'Employees on leave today',
        value: todayOnLeaveCount,
        tone: 'text-sky-600',
        tab: 'leave-approvals-inbox',
      },
      {
        label: 'Inactive employee profiles',
        value: inactiveEmployeesCount,
        tone: inactiveEmployeesCount > 0 ? 'text-muted-foreground' : 'text-emerald-600',
        tab: 'employees',
      },
    ],
    [inactiveEmployeesCount, pendingEnrollmentCount, todayOnLeaveCount, unresolvedFraudCount]
  );

  const upcomingAnniversaries = useMemo(() => {
    const today = new Date();
    const windowEnd = new Date(today);
    windowEnd.setDate(windowEnd.getDate() + 45);

    return employees
      .filter((employee) => employee.is_active !== false && employee.date_of_joining)
      .map((employee) => {
        const joinDate = new Date(employee.date_of_joining);
        if (Number.isNaN(joinDate.getTime())) return null;
        const anniversary = new Date(today.getFullYear(), joinDate.getMonth(), joinDate.getDate());
        if (anniversary < today) {
          anniversary.setFullYear(today.getFullYear() + 1);
        }
        const years = anniversary.getFullYear() - joinDate.getFullYear();
        return {
          employee_id: employee.employee_id,
          name: `${employee.first_name || ''} ${employee.last_name || ''}`.trim() || employee.employee_id,
          department: employee.department || 'Unassigned',
          dateLabel: format(anniversary, 'dd MMM'),
          years,
          anniversary,
        };
      })
      .filter(Boolean)
      .filter((item) => item.anniversary <= windowEnd)
      .sort((a, b) => a.anniversary - b.anniversary)
      .slice(0, 5);
  }, [employees]);

  const handleNavigate = async (tab) => {
    if (tab === 'return_superadmin') {
      if (user?.canReturnToSuperadmin) {
        try {
          await exitProxy();
          navigate('/superadmin');
        } catch (error) {
          toast.error(getErrorMessage(error, 'Failed to return to Superadmin'));
        }
        return;
      }
      navigate('/superadmin');
      return;
    }
    const explicitRouteByTab = {
      'master-departments': '/admin/master/departments',
      'master-subdepartments': '/admin/master/subdepartments',
      'master-designations': '/admin/master/designations',
      'rules-departments': '/admin/master/departments',
      'rules-penalties': '/admin/attendance-rules',
      geofence: '/admin/geofence',
    };
    if (explicitRouteByTab[tab]) {
      setActiveTab(tab === 'rules-departments' ? 'master-departments' : tab);
      navigate(explicitRouteByTab[tab]);
      return;
    }
    setActiveTab(tab);
  };

  const resolveAdminTabComponent = () => {
    if (activeTab === 'ai-command') {
      return <TenantAICommandCenterPage />;
    }
    if (activeTab === 'ai-assistant' || activeTab === 'ai-assistant-chat') {
      return <AIAssistant />;
    }
    if (activeTab === 'ai-assistant-agents') {
      return <AIAgentBuilder />;
    }
    if (activeTab === 'ai-assistant-usage') {
      return <AIUsageDashboard />;
    }
    if (activeTab === 'ai-assistant-settings') {
      return <AIAssistantSettings />;
    }

    if (activeTab === 'ai-center' || activeTab === 'ai-center-attendance-insight') {
      return <AICenterFeaturePage featureKey="attendance-insight" scope="tenant" />;
    }

    if (activeTab === 'ai-center-hiring-forecast') {
      return <AICenterFeaturePage featureKey="hiring-forecast" scope="tenant" />;
    }

    if (activeTab === 'ai-center-payroll-forecast') {
      return <AICenterFeaturePage featureKey="payroll-forecast" scope="tenant" />;
    }

    if (activeTab === 'ai-center-team-performance') {
      return <AICenterFeaturePage featureKey="team-performance" scope="tenant" />;
    }

    if (activeTab === 'ai-center-settings') {
      return <AICenterSettingsPage scope="tenant" />;
    }

    if (activeTab.startsWith('onboarding-')) {
      if (activeTab === 'onboarding-checklists') {
        return <AdminOnboardingChecklistsPage />;
      }
      return <OnboardingManagement currentTab={activeTab.replace('onboarding-', '')} />;
    }

    if (activeTab.startsWith('leave-my-')) {
      return <LeaveSection currentTab={activeTab.replace('leave-my-', '')} />;
    }

    if (activeTab === 'leave-approvals-inbox') {
      return <ApprovalsInboxModule />;
    }

    if (activeTab === 'leave-regularization' || activeTab === 'leave-wfh' || activeTab === 'leave-outstation') {
      return (
        <WorkRequestModule
          mode="admin"
          requestType={activeTab === 'leave-regularization' ? 'regularization' : activeTab === 'leave-wfh' ? 'wfh' : 'outstation'}
        />
      );
    }

    if (activeTab === 'leave-types') {
      return <LeaveTypesManagement />;
    }

    if (activeTab.startsWith('growth-')) {
      return <GrowthModule currentTab={activeTab.replace('growth-', '')} />;
    }
    if (activeTab.startsWith('workplace-')) {
      return <WorkplaceModule currentTab={activeTab.replace('workplace-', '')} onNavigate={setActiveTab} />;
    }
    if (activeTab.startsWith('account-')) {
      return <MyAccountModule currentTab={activeTab.replace('account-', '')} />;
    }
    if (activeTab === 'rebranding' || activeTab.startsWith('rebranding-')) {
      return <RebrandingModule currentTab={activeTab.replace('rebranding-', '')} />;
    }
    if (activeTab === 'access-control') {
      return <TenantAccessControl />;
    }

    if (activeTab.startsWith('leave-')) {
      return <LeaveManagement currentTab={activeTab.replace('leave-', '')} />;
    }

    if (activeTab.startsWith('finance-')) {
      if (activeTab === 'finance-structures') {
        return <AdminSalaryStructuresPage />;
      }
      if (activeTab === 'finance-tax-slabs') {
        return <AdminTaxSlabsPage />;
      }
      const financeTabMap = {
        'finance-home': 'overview',
        'finance-my': 'my-salary',
        'finance-process': 'payroll-process',
        'finance-payslips': 'payslips',
        'finance-config': 'employee-salaries',
        'finance-structures': 'salary-structures',
        'finance-tax-slabs': 'tax-slabs',
        'finance-reimbursements': 'reimbursements',
      };
      return <PayrollManagement currentTab={financeTabMap[activeTab] || 'overview'} hiddenTabs={['salary-structures', 'tax-slabs']} />;
    }

    if (activeTab.startsWith('benefits-')) {
      if (activeTab === 'benefits-plans') {
        return <AdminBenefitsPlansPage />;
      }
      return <BenefitsManagement currentTab={activeTab.replace('benefits-', '')} hiddenTabs={['plans']} />;
    }

    if (activeTab.startsWith('rules-')) {
      if (activeTab === 'rules-shifts') return <AdminAttendanceShiftConfigPage />;
      if (activeTab === 'rules-penalties') return <AdminAttendanceRulesOnlyPage />;
      return <AttendanceRuleConfig currentTab="shifts" />;
    }

    if (activeTab.startsWith('report-')) {
      if (activeTab === 'report-center') {
        return <ReportEngine />;
      }
      if (activeTab === 'report-executive') {
        return <ExecutiveAnalyticsDashboard />;
      }
      const reportsTabMap = {
        'report-balance': 'leave_balance',
        'report-statutory': 'statutory_compliance',
        'report-performance': 'performance',
      };
      return <ReportsHub currentTab={reportsTabMap[activeTab] || activeTab.replace('report-', '')} />;
    }

    if (activeTab.startsWith('gamification-')) {
      return <GamificationModuleDeferred mode="admin" activeTab={activeTab} onNavigate={setActiveTab} />;
    }

    if (activeTab === 'action-center') {
      return <HRActionCenter />;
    }

    if (activeTab === 'hr-operations') {
      return <HROperationsModule />;
    }

    if (activeTab === 'hr-lifecycle') {
      return <HRLifecycleManagement />;
    }

    if (activeTab === 'exit-management') {
      return <ExitManagement />;
    }

    if (activeTab === 'contracts') {
      return <ContractsManagement />;
    }

    if (activeTab === 'doc-templates') {
      return <DocumentTemplates />;
    }

    if (activeTab === 'integrations') {
      return <IntegrationsManagement />;
    }
    if (activeTab === 'equity') {
      return <EquityManagement />;
    }
    if (activeTab === 'my-equity') {
      return <MyEquity />;
    }
    if (activeTab === 'org-legal-entities') {
      return <LegalEntitiesPage />;
    }
    if (activeTab === 'org-business-units') {
      return <BusinessUnitsPage />;
    }
    if (activeTab === 'enterprise-sso') {
      return <EnterpriseSsoSettings />;
    }
    if (activeTab === 'session-governance') {
      return <SessionGovernanceModule />;
    }
    if (activeTab === 'plan-catalog') {
      return <PlanCatalogModule />;
    }
    if (activeTab === 'edu-schools') {
      return <EducationSchoolsPage />;
    }
    if (activeTab === 'edu-departments') {
      return <EducationDepartmentsPage />;
    }
    if (activeTab === 'edu-faculty') {
      return <EducationFacultyManagement />;
    }
    if (activeTab === 'edu-calendar') {
      return <EducationCalendarManagement />;
    }
    if (activeTab === 'edu-timetable') {
      return <EducationTimetableManagement />;
    }
    if (activeTab === 'edu-courses') {
      return <EducationCoursesPage />;
    }
    if (activeTab === 'edu-rooms') {
      return <EducationRoomsPage />;
    }
    if (activeTab === 'edu-contracts') {
      return <EducationContractsManagement />;
    }
    if (activeTab === 'edu-accreditation') {
      return <EducationAccreditationManagement />;
    }
    if (activeTab === 'edu-research') {
      return <EducationResearchManagement />;
    }
    if (activeTab === 'edu-grievance') {
      return <EducationGrievanceManagement />;
    }
    if (activeTab === 'edu-student-workers') {
      return <EducationStudentWorkerManagement />;
    }
    if (activeTab === 'edu-adjunct') {
      return <EducationAdjunctManagement />;
    }
    if (activeTab === 'edu-integrations') {
      return <EducationIntegrationsManagement />;
    }

    const staticTabComponents = {
      attendance: (
        <AttendanceManagement
          overviewStats={{
            todayAttendance: stats.todayAttendance,
            attendanceRate: employees.length > 0 ? (stats.todayAttendance / employees.length) * 100 : 0,
            totalEmployees: stats.totalEmployees,
          }}
          trendData={attTrend}
          hiddenTabs={['shifts', 'rules']}
        />
      ),
      team: <TeamSection />,
      helpdesk: <HelpdeskModule mode="admin" />,
      'pulse-surveys': <PulseSurveysModule />,
      fraud: <FraudAnalyticsDashboard />,
      geofence: <GeofenceManagement />,
      profile: <ProfileSection />,
      subtenants: canAccessChildTenantPage ? <SubTenantsCombinedDashboard /> : null,
      'subtenant-create': canAccessChildTenantPage ? (
        <SubTenantCreationPanel
          mode="tenant"
          title="Create Tenant"
          description="Create a tenant under your current tenant with governance limited to your subscribed scope."
          defaultParentTenantId={user?.tenantId}
          onCreated={() => setActiveTab('workspace')}
        />
      ) : null,
    };

    return staticTabComponents[activeTab] || null;
  };

  const employeeProfileRouteMatch = location.pathname.match(/^\/admin\/employees\/([^/]+)\/profile$/);
  const employeeEditRouteMatch = location.pathname.match(/^\/admin\/employees\/([^/]+)\/edit$/);
  const employeeCreateRouteMatch = location.pathname.match(/^\/admin\/employees\/new$/);
  const shiftCreateRouteMatch = location.pathname.match(/^\/admin\/rules-shifts\/create$/);
  const attendanceRulesRouteMatch = location.pathname.match(/^\/admin\/attendance-rules$/);
  const attendanceRuleCreateRouteMatch = location.pathname.match(/^\/admin\/attendance-rules\/new$/);
  const attendanceRuleEntityRouteMatch = location.pathname.match(/^\/admin\/attendance-rules\/([^/]+)\/(view|edit|delete)$/);
  const geofenceRouteMatch = location.pathname.match(/^\/admin\/geofence$/);
  const onboardingWizardRouteMatch = location.pathname.match(/^\/admin\/onboarding-wizard\/([^/]+)$/);
  const importRouteMatch = location.pathname.match(/^\/admin\/import\/([^/]+)$/);
  const departmentsMasterRouteMatch = location.pathname.match(/^\/admin\/master\/departments$/);
  const subDepartmentsMasterRouteMatch = location.pathname.match(/^\/admin\/master\/subdepartments$/);
  const designationsMasterRouteMatch = location.pathname.match(/^\/admin\/master\/designations$/);
  const masterCreateRouteMatch = location.pathname.match(/^\/admin\/master\/(departments|subdepartments|designations)\/new$/);
  const masterEntityRouteMatch = location.pathname.match(/^\/admin\/master\/(departments|subdepartments|designations)\/([^/]+)\/(view|edit|delete)$/);
  const legacySubDeptDesigRouteMatch = location.pathname.match(/^\/admin\/master\/subdepartments-designations$/);
  const employeeProfileRouteId = employeeProfileRouteMatch ? decodeURIComponent(employeeProfileRouteMatch[1]) : null;
  const employeeEditRouteId = employeeEditRouteMatch ? decodeURIComponent(employeeEditRouteMatch[1]) : null;
  const isEmployeeCreateRoute = Boolean(employeeCreateRouteMatch);
  const isShiftCreateRoute = Boolean(shiftCreateRouteMatch);
  const isAttendanceRulesRoute = Boolean(attendanceRulesRouteMatch);
  const isAttendanceRuleCreateRoute = Boolean(attendanceRuleCreateRouteMatch);
  const attendanceRuleRouteId = attendanceRuleEntityRouteMatch ? decodeURIComponent(attendanceRuleEntityRouteMatch[1]) : null;
  const attendanceRuleRouteMode = attendanceRuleEntityRouteMatch ? decodeURIComponent(attendanceRuleEntityRouteMatch[2]) : null;
  const isAttendanceRuleEntityRoute = Boolean(attendanceRuleRouteId && attendanceRuleRouteMode);
  const isGeofenceRoute = Boolean(geofenceRouteMatch);
  const onboardingWizardRouteId = onboardingWizardRouteMatch ? decodeURIComponent(onboardingWizardRouteMatch[1]) : null;
  const importMasterType = importRouteMatch ? decodeURIComponent(importRouteMatch[1]) : null;
  const masterCreateEntityType = masterCreateRouteMatch ? decodeURIComponent(masterCreateRouteMatch[1]) : null;
  const masterEntityType = masterEntityRouteMatch ? decodeURIComponent(masterEntityRouteMatch[1]) : null;
  const masterEntityRouteId = masterEntityRouteMatch ? decodeURIComponent(masterEntityRouteMatch[2]) : null;
  const masterEntityMode = masterEntityRouteMatch ? decodeURIComponent(masterEntityRouteMatch[3]) : null;
  const isDepartmentsMasterRoute = Boolean(departmentsMasterRouteMatch);
  const isSubDepartmentsMasterRoute = Boolean(subDepartmentsMasterRouteMatch);
  const isDesignationsMasterRoute = Boolean(designationsMasterRouteMatch || legacySubDeptDesigRouteMatch);
  const isMasterCreateRoute = Boolean(masterCreateEntityType);
  const isMasterEntityRoute = Boolean(masterEntityType && masterEntityRouteId && masterEntityMode);
  const hasDedicatedAdminPage = Boolean(
    employeeProfileRouteId ||
      employeeEditRouteId ||
      isEmployeeCreateRoute ||
      isShiftCreateRoute ||
      isAttendanceRulesRoute ||
      isAttendanceRuleCreateRoute ||
      isAttendanceRuleEntityRoute ||
      isGeofenceRoute ||
      onboardingWizardRouteId ||
      importMasterType ||
      isMasterCreateRoute ||
      isMasterEntityRoute ||
      isDepartmentsMasterRoute ||
      isSubDepartmentsMasterRoute ||
      isDesignationsMasterRoute
  );

  return (
    <Layout 
      items={navItems} 
      activeItem={activeTab} 
      onNavigate={handleNavigate} 
      onLogout={logout}
    >
      <div className="space-y-6" data-testid="admin-dashboard">
        {employeeProfileRouteId && (
          <AdminEmployeeProfilePage employeeId={employeeProfileRouteId} />
        )}
        {employeeEditRouteId && (
          <AdminEmployeeEditPage employeeId={employeeEditRouteId} />
        )}
        {isEmployeeCreateRoute && (
          <AdminEmployeeCreatePage />
        )}
        {isShiftCreateRoute && (
          <AdminAttendanceShiftCreatePage />
        )}
        {isAttendanceRulesRoute && (
          <AdminAttendanceRulesOnlyPage />
        )}
        {isAttendanceRuleCreateRoute && (
          <AdminAttendanceRuleCrudPage mode="create" />
        )}
        {isAttendanceRuleEntityRoute && (
          <AdminAttendanceRuleCrudPage mode={attendanceRuleRouteMode} ruleId={attendanceRuleRouteId} />
        )}
        {isGeofenceRoute && (
          <AdminGeofencePage />
        )}
        {onboardingWizardRouteId && (
          <AdminEmployeeOnboardingWizardPage employeeId={onboardingWizardRouteId} />
        )}
        {importMasterType && (
          <AdminMasterImportPage masterType={importMasterType} />
        )}
        {isMasterCreateRoute && (
          <AdminMasterEntityPage entityType={masterCreateEntityType} mode="create" />
        )}
        {isMasterEntityRoute && (
          <AdminMasterEntityPage entityType={masterEntityType} entityId={masterEntityRouteId} mode={masterEntityMode} />
        )}
        {isDepartmentsMasterRoute && (
          <AdminDepartmentsMasterPage />
        )}
        {isSubDepartmentsMasterRoute && (
          <AdminSubDepartmentsMasterPage />
        )}
        {isDesignationsMasterRoute && (
          <AdminDesignationsMasterPage />
        )}
        {!hasDedicatedAdminPage && (
          <>
        {activeTab !== 'ai-command' && !activeTab.startsWith('ai-center') && (
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h1 className="text-hr-h1 font-bold">{roleDashboardMeta.title}</h1>
              <p className="text-muted-foreground">{roleDashboardMeta.subtitle}</p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="outline" className="font-medium">
                {roleDashboardMeta.badge}
              </Badge>
              <Badge variant="outline" className="font-medium">
                {roleDashboardMeta.highlight}
              </Badge>
            </div>
          </div>
        )}

        {activeTab === 'dashboard' && (
          <div className="space-y-6 animate-fade-in">
          <IndustryRecommendedAddons />
          <Card className="overflow-hidden border-primary/20 bg-gradient-to-br from-primary/10 via-card to-[hsl(var(--chart-2))]/10 shadow-sm">
            <CardContent className="pt-6">
              <div className="grid gap-6 xl:grid-cols-[1.4fr_0.9fr]">
                <div className="space-y-5">
                  <div className="inline-flex items-center gap-2 rounded-full border border-primary/15 bg-card/80 px-3 py-1 text-xs font-medium text-primary">
                    <Activity className="h-3.5 w-3.5" />
                    Live tenant operations
                  </div>
                  <div className="space-y-2">
                    <h2 className="text-3xl font-semibold tracking-tight text-foreground">
                      {(() => { const h = new Date().getHours(); return h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening'; })()}
                      {user?.name ? `, ${String(user.name).split(' ')[0]}` : ''} 👋
                    </h2>
                    <p className="max-w-3xl text-sm text-muted-foreground">
                      Here’s your workforce at a glance — attendance, compliance, onboarding, and pending actions in one command view so you can act on exceptions faster.
                    </p>
                  </div>
                  <div className="grid gap-3 sm:grid-cols-3">
                    <div className="rounded-xl border border-border bg-card/80 p-4 shadow-sm">
                      <p className="text-xs font-medium text-muted-foreground">Active {term('employees', 'Employees')}</p>
                      <p className="mt-2 text-2xl font-semibold text-foreground">{activeEmployeesCount}</p>
                      <p className="mt-1 text-xs text-muted-foreground">{attendanceRateToday.toFixed(1)}% attendance captured today</p>
                    </div>
                    <div className="rounded-xl border border-border bg-card/80 p-4 shadow-sm">
                      <p className="text-xs font-medium text-muted-foreground">Pending Enrollment</p>
                      <p className="mt-2 text-2xl font-semibold text-foreground">{pendingEnrollmentCount}</p>
                      <p className="mt-1 text-xs text-muted-foreground">Biometric profiles still pending</p>
                    </div>
                    <div className="rounded-xl border border-border bg-card/80 p-4 shadow-sm">
                      <p className="text-xs font-medium text-muted-foreground">Critical Alerts</p>
                      <p className="mt-2 text-2xl font-semibold text-foreground">{unresolvedFraudCount}</p>
                      <p className="mt-1 text-xs text-muted-foreground">Exceptions requiring review</p>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-3">
                    <Button className="hover-lift" onClick={openEmployeeCreatePage}>
                      <UserPlus className="mr-2 h-4 w-4" />
                      Add Employee
                    </Button>
                    <Button variant="outline" className="hover-lift" onClick={() => setActiveTab('leave-approvals-inbox')}>
                      <FileText className="mr-2 h-4 w-4" />
                      Open Approvals
                    </Button>
                    <Button variant="outline" className="hover-lift" onClick={() => setActiveTab('workspace')}>
                      <ShieldCheck className="mr-2 h-4 w-4" />
                      Workspace Setup
                    </Button>
                    {canAccessChildTenantPage ? (
                      <Button variant="outline" className="hover-lift" onClick={() => setActiveTab('subtenant-create')}>
                        <Building2 className="mr-2 h-4 w-4" />
                        Add Sub-Tenant
                      </Button>
                    ) : null}
                  </div>
                </div>

                <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-1">
                  {adminPriorityItems.map((item, index) => (
                    <button
                      key={item.label}
                      type="button"
                      onClick={() => setActiveTab(item.tab)}
                      className="animate-slide-up rounded-xl border border-border bg-card/85 p-4 text-left shadow-sm transition-all duration-200 hover:-translate-y-1 hover:border-primary/20 hover:shadow-md"
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <p className="text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">Attention</p>
                      <p className={`mt-2 text-2xl font-semibold ${item.tone}`}>{item.value}</p>
                      <p className="mt-2 text-sm text-muted-foreground">{item.label}</p>
                    </button>
                  ))}
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Executive widget grid — workforce, calendar & people signals */}
          <div className="grid gap-4 lg:grid-cols-3">
            <WorkforceDistribution employees={employees} />
            <DepartmentSummary employees={employees} />
            <MiniCalendar holidays={holidayDates} />
          </div>
          <div className="grid gap-4 lg:grid-cols-3">
            <UpcomingBirthdays employees={employees} />
            <UpcomingHolidays holidays={holidayDates} />
            <RecentHires employees={employees} onView={(e) => openEmployeeProfilePage(e.employee_id)} />
          </div>

          <div className="grid md:grid-cols-4 gap-4">
            {attendanceSignals.map((item) => {
              const isUp = item.deltaPct >= 0;
              const DeltaIcon = isUp ? TrendingUp : TrendingDown;
              const SignalIcon = item.icon;
              return (
                <Card key={item.key} className="border-border shadow-sm">
                  <CardContent className="pt-5">
                    <div className="flex items-start justify-between">
                      <div>
                        <p className="text-xs text-muted-foreground">{item.label}</p>
                        <p className="text-3xl font-bold mt-1">{item.value}</p>
                      </div>
                      <div className="p-2 rounded-lg bg-primary/10">
                        <SignalIcon className="h-4 w-4 text-primary" />
                      </div>
                    </div>
                    <div className={`mt-3 flex items-center gap-1 text-xs ${isUp ? 'text-emerald-600' : 'text-red-600'}`}>
                      <DeltaIcon className="h-3 w-3" />
                      <span>{Math.abs(item.deltaPct).toFixed(1)}% vs yesterday</span>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="grid gap-6 xl:grid-cols-[1.2fr_0.8fr_0.9fr]">
            <Card className="lg:col-span-2 border-border shadow-sm">
              <CardHeader className="border-b border-border/50">
                <div className="flex items-center justify-between gap-3">
                  <CardTitle className="text-foreground">Attendance Trend</CardTitle>
                  <div className="flex items-center gap-2">
                    {['daily', 'weekly', 'monthly'].map((mode) => (
                      <Button
                        key={mode}
                        size="sm"
                        variant={attendanceTrendMode === mode ? 'default' : 'outline'}
                        onClick={() => setAttendanceTrendMode(mode)}
                        className="capitalize"
                      >
                        {mode}
                      </Button>
                    ))}
                  </div>
                </div>
              </CardHeader>
              <CardContent className="h-[320px] pt-6">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={attendanceTrendData}>
                    <CartesianGrid {...gridProps} />
                    <XAxis dataKey="label" hide={attendanceTrendMode === 'weekly'} {...axisProps} />
                    <YAxis {...axisProps} allowDecimals={false} />
                    <Tooltip contentStyle={tooltipContentStyle} cursor={tooltipCursor} />
                    <Bar dataKey="value" fill="hsl(var(--primary))" radius={[6, 6, 0, 0]} maxBarSize={48} />
                  </BarChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>

            <Card className="border-border shadow-sm">
              <CardHeader className="border-b border-border/50">
                <CardTitle className="text-foreground">Quick Actions</CardTitle>
              </CardHeader>
              <CardContent className="pt-6 space-y-3">
                <Button className="w-full justify-start" onClick={() => setActiveTab('attendance')}>
                  <Calendar className="h-4 w-4 mr-2" />
                  Mark Attendance
                </Button>
                <Button
                  className="w-full justify-start"
                  variant="outline"
                  onClick={openEmployeeCreatePage}
                >
                  <UserPlus className="h-4 w-4 mr-2" />
                  Add Employee
                </Button>
                <Button
                  className="w-full justify-start"
                  variant="secondary"
                  onClick={() => setActiveTab('leave-approvals-inbox')}
                >
                  <FileText className="h-4 w-4 mr-2" />
                  Approve Leaves
                </Button>
                <Button
                  className="w-full justify-start"
                  variant="outline"
                  onClick={() => setActiveTab('report-center')}
                >
                  <BarChart3 className="h-4 w-4 mr-2" />
                  View Reports
                </Button>
                {canAccessChildTenantPage ? (
                  <Button
                    className="w-full justify-start"
                    variant="outline"
                    onClick={() => setActiveTab('subtenant-create')}
                  >
                    <Building2 className="h-4 w-4 mr-2" />
                    Add Sub-Tenant
                  </Button>
                ) : null}
              </CardContent>
            </Card>

            <Card className="border-border shadow-sm">
              <CardHeader className="border-b border-border/50">
                <CardTitle className="text-foreground">Upcoming Anniversaries</CardTitle>
              </CardHeader>
              <CardContent className="pt-6 space-y-3">
                {upcomingAnniversaries.map((employee, index) => (
                  <button
                    key={employee.employee_id}
                    type="button"
                    className="flex w-full items-center justify-between rounded-xl border border-slate-200 bg-card p-3 text-left transition-all duration-200 hover:-translate-y-0.5 hover:border-primary/20 hover:bg-slate-50"
                    style={{ animationDelay: `${index * 0.05}s` }}
                    onClick={() => openEmployeeProfilePage(employee.employee_id)}
                  >
                    <div>
                      <p className="text-sm font-medium text-foreground">{employee.name}</p>
                      <p className="text-xs text-muted-foreground">{employee.department}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-sm font-semibold text-foreground">{employee.dateLabel}</p>
                      <p className="text-xs text-muted-foreground">{employee.years} yr{employee.years === 1 ? '' : 's'}</p>
                    </div>
                  </button>
                ))}
                {upcomingAnniversaries.length === 0 && (
                  <p className="text-sm text-muted-foreground">No anniversaries in the next 45 days.</p>
                )}
              </CardContent>
            </Card>
          </div>

          <Card className="border-border shadow-sm">
            <CardHeader className="border-b border-border/50">
              <CardTitle className="text-foreground flex items-center gap-2">
                <Activity className="h-4 w-4" />
                Recent Activity / Logs
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-5 space-y-3">
              {adminActivityFeed.map((entry, idx) => (
                <div key={`${entry.message}-${idx}`} className="flex items-center justify-between rounded-md border p-3">
                  <p className="text-sm">{entry.message}</p>
                  <p className="text-xs text-muted-foreground">{entry.at.toLocaleString()}</p>
                </div>
              ))}
              {adminActivityFeed.length === 0 && (
                <p className="text-sm text-muted-foreground">No recent activity yet.</p>
              )}
            </CardContent>
          </Card>

          <div className="grid md:grid-cols-4 gap-4">
            <ClickableKpiCard
              title={`Total ${term('employees', 'Employees')}`}
              value={employees.length}
              hint="Includes all active employees in the organization."
              icon={Users}
              iconWrapClassName="p-2 bg-[hsl(var(--chart-1))]/10 rounded-lg"
              iconClassName="h-4 w-4 text-[hsl(var(--chart-1))]"
              cardClassName="hover-lift bg-card border-border shadow-sm animate-slide-up"
              onClick={() => openDashboardCardDetail({
                title: 'Total Employees',
                value: employees.length,
                description: 'Includes all active employees in the organization.',
                openAction: () => handleCardClick('/employees'),
              })}
            />
            <ClickableKpiCard
              title="Biometric Enrolled"
              value={stats.enrolledEmployees}
              hint={`${employees.length > 0 ? ((stats.enrolledEmployees / employees.length) * 100).toFixed(1) : 0}% of employees have completed biometric enrollment.`}
              icon={Fingerprint}
              iconWrapClassName="p-2 bg-[hsl(var(--chart-2))]/10 rounded-lg"
              iconClassName="h-4 w-4 text-[hsl(var(--chart-2))]"
              cardClassName="hover-lift bg-card border-border shadow-sm animate-slide-up"
              onClick={() => openDashboardCardDetail({
                title: 'Biometric Enrolled',
                value: stats.enrolledEmployees,
                description: `${employees.length > 0 ? ((stats.enrolledEmployees / employees.length) * 100).toFixed(1) : 0}% of employees have completed biometric enrollment.`,
                openAction: () => handleCardClick('/employees?filter=enrolled'),
              })}
            />
            <ClickableKpiCard
              title="Fraud Alerts"
              value={fraudAlerts.length}
              hint="Potential attendance anomalies requiring investigation and resolution."
              icon={AlertTriangle}
              iconWrapClassName="p-2 bg-[hsl(var(--chart-4))]/10 rounded-lg"
              iconClassName="h-4 w-4 text-[hsl(var(--chart-4))]"
              valueClassName="text-hr-h2 font-bold text-[hsl(var(--chart-4))]"
              cardClassName="hover-lift bg-card border-border shadow-sm animate-slide-up"
              onClick={() => openDashboardCardDetail({
                title: 'Fraud Alerts',
                value: fraudAlerts.length,
                description: 'Potential attendance anomalies requiring investigation and resolution.',
                openAction: () => handleCardClick('/fraud-analytics'),
              })}
            />
            <ClickableKpiCard
              title="Active Geofences"
              value={4}
              hint="Configured office location boundaries used for attendance validation."
              icon={MapPin}
              iconWrapClassName="p-2 bg-[hsl(var(--chart-3))]/10 rounded-lg"
              iconClassName="h-4 w-4 text-[hsl(var(--chart-3))]"
              valueClassName="text-hr-h2 font-bold text-[hsl(var(--chart-3))]"
              cardClassName="hover-lift bg-card border-border shadow-sm animate-slide-up"
              onClick={() => openDashboardCardDetail({
                title: 'Active Geofences',
                value: 4,
                description: 'Configured office location boundaries used for attendance validation.',
                openAction: () => handleCardClick('/geofence-management'),
              })}
            />
          </div>

          <KpiDetailPanel
            detail={dashboardCardDetail}
            onClose={() => setDashboardCardDetail(null)}
            onOpenModule={() => dashboardCardDetail?.openAction?.()}
            className="border-primary/20 bg-primary/5 mt-2"
          />
          
          <div className="grid md:grid-cols-2 gap-6 mt-6">
            <Card className="hover-lift bg-card border-border shadow-sm animate-slide-up" style={{ animationDelay: '0.5s' }}>
              <CardHeader className="border-b border-border/50">
                <CardTitle className="text-foreground">Biometric Enrollment Status</CardTitle>
              </CardHeader>
              <CardContent className="h-[300px] pt-6">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={enrollmentData}
                      cx="50%"
                      cy="50%"
                      innerRadius={60}
                      outerRadius={85}
                      paddingAngle={5}
                      dataKey="value"
                      animationDuration={1500}
                    >
                      {enrollmentData.map((entry, index) => (
                        <Cell key={`enrollment-cell-${index}`} fill={COLORS[index % COLORS.length]} stroke="none" />
                      ))}
                    </Pie>
                    <Tooltip contentStyle={{ borderRadius: '8px', border: '1px solid hsl(var(--border))', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)', backgroundColor: 'hsl(var(--card))', color: 'hsl(var(--foreground))' }} />
                    <Legend wrapperStyle={{ paddingTop: '20px' }} />
                  </PieChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>

            <Card className="hover-lift bg-card border-border shadow-sm animate-slide-up" style={{ animationDelay: '0.6s' }}>
              <CardHeader className="border-b border-border/50">
                <CardTitle className="text-foreground">{term('employees', 'Employees')} Distribution by {term('department', 'Department')}</CardTitle>
              </CardHeader>
              <CardContent className="h-[300px] pt-6">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={deptData}
                      cx="50%"
                      cy="50%"
                      innerRadius={60}
                      outerRadius={80}
                      paddingAngle={5}
                      dataKey="value"
                      animationDuration={1500}
                    >
                      {deptData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} stroke="none" />
                      ))}
                    </Pie>
                    <Tooltip contentStyle={{ borderRadius: '8px', border: '1px solid hsl(var(--border))', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)', backgroundColor: 'hsl(var(--card))', color: 'hsl(var(--foreground))' }} />
                    <Legend 
                      layout="vertical" 
                      verticalAlign="middle" 
                      align="right"
                      content={({ payload }) => (
                        <ul className="flex flex-col gap-2">
                          {payload.map((entry, index) => (
                            <li key={`item-${index}`} className="flex items-center gap-2">
                              <div className="w-2 h-2 rounded-full" style={{ backgroundColor: entry.color }} />
                              <span className="text-sm text-muted-foreground">{entry.value}</span>
                            </li>
                          ))}
                        </ul>
                      )}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </div>

          {performanceOverview && (
            <div className="grid md:grid-cols-3 gap-6 mt-6">
              <Card className="hover-lift bg-card border-border shadow-sm animate-slide-up">
                <CardHeader className="border-b border-border/50">
                  <CardTitle className="text-foreground">Average KPI Score</CardTitle>
                </CardHeader>
                <CardContent className="pt-4">
                  <div className="text-hr-h2 font-bold text-primary">{performanceOverview.average_overall_score}</div>
                  <p className="text-hr-xs text-muted-foreground mt-2">Across {performanceOverview.employee_count} active employees</p>
                </CardContent>
              </Card>

              <Card className="hover-lift bg-card border-border shadow-sm animate-slide-up">
                <CardHeader className="border-b border-border/50">
                  <CardTitle className="text-foreground">Performance Parameters</CardTitle>
                </CardHeader>
                <CardContent className="pt-4 space-y-2 text-hr-sm">
                  <div className="flex justify-between"><span className="text-muted-foreground">Goal Achievement</span><span className="font-semibold">{performanceOverview.average_goal_achievement}</span></div>
                  <div className="flex justify-between"><span className="text-muted-foreground">Work Quality</span><span className="font-semibold">{performanceOverview.average_quality_score}</span></div>
                  <div className="flex justify-between"><span className="text-muted-foreground">Time Management</span><span className="font-semibold">{performanceOverview.average_time_management_score}</span></div>
                  <div className="flex justify-between"><span className="text-muted-foreground">360 Feedback</span><span className="font-semibold">{performanceOverview.average_feedback_360_score}</span></div>
                </CardContent>
              </Card>

              <Card className="hover-lift bg-card border-border shadow-sm animate-slide-up">
                <CardHeader className="border-b border-border/50">
                  <CardTitle className="text-foreground">Top Performing {term('employees', 'Employees')}</CardTitle>
                </CardHeader>
                <CardContent className="pt-4 space-y-2">
                  {(performanceOverview.top_performers || []).map((row, idx) => (
                    <button
                      key={row.employee_id}
                      type="button"
                      className="w-full text-left rounded-md border p-2 flex items-center justify-between hover:bg-muted/40 transition-colors"
                      onClick={() => openPerformerDetail(row.employee_id)}
                    >
                      <div>
                        <p className="text-hr-sm font-medium">#{idx + 1} {row.employee_name}</p>
                        <p className="text-hr-xs text-muted-foreground">{row.department || 'N/A'} • {row.designation || 'N/A'}</p>
                      </div>
                      <Badge variant={idx === 0 ? 'success' : 'outline'}>{row.overall_score}</Badge>
                    </button>
                  ))}
                </CardContent>
              </Card>
            </div>
          )}

          <Card className="hover-lift bg-card border-border shadow-sm animate-slide-up mt-6">
            <CardHeader className="border-b border-border/50">
              <CardTitle className="text-foreground">Set KPI Values (HR Admin)</CardTitle>
            </CardHeader>
            <CardContent className="pt-4 space-y-4">
              <div className="grid md:grid-cols-4 gap-3">
                <div className="md:col-span-2">
                  <Label>Employee</Label>
                  <Select value={kpiForm.employee_id} onValueChange={(v) => updateKpiFormField('employee_id', v)}>
                    <SelectTrigger>
                      <SelectValue placeholder="Select employee" />
                    </SelectTrigger>
                    <SelectContent>
                      {employees.map((emp) => (
                        <SelectItem key={emp.employee_id} value={emp.employee_id}>
                          {emp.first_name} {emp.last_name} ({emp.employee_id})
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Month</Label>
                  <Select value={String(kpiForm.month)} onValueChange={(v) => updateKpiFormField('month', Number(v))}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                        <SelectItem key={m} value={String(m)}>
                          {m}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Year</Label>
                  <Input
                    type="number"
                    value={kpiForm.year}
                    onChange={(e) => updateKpiFormField('year', Number(e.target.value))}
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-3">
                <div>
                  <Label>Goal Achievement</Label>
                  <Input type="number" min="0" max="100" value={kpiForm.goal_achievement} onChange={(e) => updateKpiFormField('goal_achievement', e.target.value)} />
                </div>
                <div>
                  <Label>Work Quality</Label>
                  <Input type="number" min="0" max="100" value={kpiForm.quality_score} onChange={(e) => updateKpiFormField('quality_score', e.target.value)} />
                </div>
                <div>
                  <Label>Time Management</Label>
                  <Input type="number" min="0" max="100" value={kpiForm.time_management_score} onChange={(e) => updateKpiFormField('time_management_score', e.target.value)} />
                </div>
                <div>
                  <Label>360 Feedback</Label>
                  <Input type="number" min="0" max="100" value={kpiForm.feedback_360_score} onChange={(e) => updateKpiFormField('feedback_360_score', e.target.value)} />
                </div>
                <div>
                  <Label>Engagement</Label>
                  <Input type="number" min="0" max="100" value={kpiForm.engagement_score} onChange={(e) => updateKpiFormField('engagement_score', e.target.value)} />
                </div>
              </div>

              <div className="flex gap-2 justify-end">
                <Button variant="outline" onClick={handleAutoCalculateKpi} disabled={kpiFormLoading || kpiFormSaving}>
                  <Wand2 className="h-4 w-4 mr-2" />
                  {kpiFormLoading ? 'Calculating...' : 'Auto Calculate'}
                </Button>
                <Button onClick={handleSaveKpiValues} disabled={kpiFormLoading || kpiFormSaving}>
                  <Save className="h-4 w-4 mr-2" />
                  {kpiFormSaving ? 'Saving...' : 'Save KPI Values'}
                </Button>
              </div>
            </CardContent>
          </Card>
          </div>
        )}

        {activeTab === 'assets' && (
          <AssetManagementModule mode="admin" />
        )}

        {activeTab === 'pf-policy' && <PfModule section="policy" />}
        {activeTab === 'pf-employees' && <PfModule section="employees" />}
        {activeTab === 'pf-contributions' && <PfModule section="contributions" />}
        {activeTab === 'pf-challans' && <PfModule section="challans" />}
        {activeTab === 'final-settlements' && <FinalSettlements />}
        {activeTab === 'tax-form16' && <TaxFilings section="form16" />}
        {activeTab === 'tax-form24q' && <TaxFilings section="form24q" />}
        {activeTab === 'esi-policy' && <EsiModule section="policy" />}
        {activeTab === 'esi-branches' && <EsiModule section="branches" />}
        {activeTab === 'esi-employees' && <EsiModule section="employees" />}
        {activeTab === 'esi-contributions' && <EsiModule section="contributions" />}
        {activeTab === 'esi-challans' && <EsiModule section="challans" />}

        {(activeTab === 'workflows' || activeTab === 'workflows-instances') && <WorkflowsScreen />}
        {activeTab === 'workflows-inbox' && <WorkflowInbox />}
        {activeTab === 'workflows-builder' && <WorkflowBuilderScreen />}
        {activeTab === 'workflows-delegations' && <WorkflowDelegations />}

        {activeTab === 'employees' && (
          <Card className="shadow-sm hover:shadow-md bg-card border-border animate-fade-in transition-all duration-200">
            <CardHeader className="border-b border-border/50 bg-muted/20">
              <div className="flex justify-between items-center">
                <div className="space-y-1">
                  <CardTitle className="text-foreground flex items-center gap-2">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <Users className="h-5 w-5 text-primary" />
                  </div>
                  {term('employee', 'Employee')} Management
                  </CardTitle>
                  <p className="text-hr-xs text-muted-foreground">Manage {term('employee', 'employee').toLowerCase()} profiles, enrollment status, and quick actions in one place.</p>
                </div>
                <div className="flex items-center gap-2">
                  <Button
                    data-testid="sync-employee-dept-button"
                    variant="outline"
                    className="hover-lift active:scale-95 transition-all"
                    onClick={handleSyncEmployeeDepartmentMapping}
                  >
                    Preview Dept Sync
                  </Button>
                  <Button data-testid="import-employee-button" variant="outline" className="hover-lift active:scale-95 transition-all" onClick={() => openImportPage('employee')}>
                    <FileText className="h-4 w-4 mr-2" />
                    Import {term('employees', 'Employees')}
                  </Button>
                  <Button data-testid="add-employee-button" className="hover-lift active:scale-95 transition-all" onClick={openEmployeeCreatePage}>
                    <UserPlus className="h-4 w-4 mr-2" />
                    Add {term('employee', 'Employee')}
                  </Button>
                </div>
              </div>
            </CardHeader>
            <CardContent className="pt-6">
              <div className="mb-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                <StatCard label="Total Employees" value={employees.length} icon={Users} tone="primary" />
                <StatCard label="Active" value={activeEmployeesCount} icon={UserCheck} tone="success" ring={employees.length ? Math.round((activeEmployeesCount / employees.length) * 100) : 0} />
                <StatCard label="On Leave Today" value={todayOnLeaveCount} icon={Calendar} tone="warning" />
                <StatCard label="Departments" value={deptData.length} icon={Building2} tone="info" />
              </div>
              <div className="mb-4 space-y-3">
                <div className="flex items-center justify-between">
                  <p className="text-hr-sm font-medium text-foreground">Employee Directory</p>
                  <div className="flex items-center gap-2">
                    <Badge variant="outline">{filteredEmployees.length} shown</Badge>
                    <Badge variant="outline">{employees.length} total</Badge>
                  </div>
                </div>
                <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-3">
                  <Input
                    placeholder="Search by name, ID, department, designation..."
                    value={employeeSearch}
                    onChange={(e) => setEmployeeSearch(e.target.value)}
                  />
                  <Select value={employeeStatusFilter} onValueChange={setEmployeeStatusFilter}>
                    <SelectTrigger>
                      <SelectValue placeholder="Filter by active status" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">All Employees</SelectItem>
                      <SelectItem value="active">Active</SelectItem>
                      <SelectItem value="inactive">Inactive</SelectItem>
                      <SelectItem value="enrolled">Enrolled</SelectItem>
                      <SelectItem value="not_enrolled">Not Enrolled</SelectItem>
                    </SelectContent>
                  </Select>
                  <Select
                    value={employeeDepartmentFilter}
                    onValueChange={(value) => {
                      setEmployeeDepartmentFilter(value);
                      setEmployeeSubDepartmentFilter('all');
                    }}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Filter by department" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">All Departments</SelectItem>
                      {employeeDepartmentOptions.map((dept) => (
                        <SelectItem key={dept} value={dept}>{dept}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <Select
                    value={employeeSubDepartmentFilter}
                    onValueChange={setEmployeeSubDepartmentFilter}
                    disabled={employeeDepartmentFilter === 'all'}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Filter by sub department" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">All Sub Departments</SelectItem>
                      {employeeSubDepartmentOptions.map((sub) => (
                        <SelectItem key={sub} value={sub}>{sub}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  {/* Offices within this workspace, as distinct from a location
                      (a separate child tenant, switched from the header). Options
                      come from the rows already loaded, the same way the
                      department filter's do — there is no office master in the
                      schema and employees.location is where the offices this
                      workspace uses are already recorded. */}
                  {(employeeOfficeOptions.length > 1 || employeeUnassignedOfficeCount > 0) ? (
                    <Select value={employeeOfficeFilter} onValueChange={setEmployeeOfficeFilter}>
                      <SelectTrigger>
                        <SelectValue placeholder="Filter by office" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="all">All Offices</SelectItem>
                        {employeeOfficeOptions.map((office) => (
                          <SelectItem key={office} value={office}>{office}</SelectItem>
                        ))}
                        {employeeUnassignedOfficeCount > 0 ? (
                          <SelectItem value="__unassigned__">
                            No office recorded ({employeeUnassignedOfficeCount})
                          </SelectItem>
                        ) : null}
                      </SelectContent>
                    </Select>
                  ) : null}
                  <div className="flex items-center md:justify-end">
                    <TableExportActions
                      rows={filteredEmployees}
                      columns={employeeExportColumns}
                      fileName="employee_directory"
                      title="Employee Directory"
                    />
                  </div>
                </div>
              </div>
              <div className="space-y-3">
                {filteredEmployees.map((emp, index) => (
                  <div 
                    key={emp.id} 
                    className="flex justify-between items-center p-3 border border-border/60 rounded-xl bg-card hover:bg-muted/40 hover:border-primary/20 transition-all duration-200 animate-slide-up group"
                    style={{ animationDelay: `${index * 0.05}s` }}
                    data-testid={`employee-row-${emp.employee_id}`}
                  >
                    <div className="flex items-center gap-3">
                      <div className="h-11 w-11 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold text-sm">
                        {(emp.first_name?.[0] || 'E').toUpperCase()}
                      </div>
                      <div>
                        <div className="flex items-center gap-2">
                          <p className="font-semibold text-foreground group-hover:text-primary transition-colors">{emp.first_name} {emp.last_name}</p>
                          <Badge variant={emp.is_active ? 'success' : 'secondary'}>{emp.is_active ? 'Active' : 'Inactive'}</Badge>
                        </div>
                        <p className="text-sm text-muted-foreground">{emp.employee_id} • {emp.department || 'N/A'} • {emp.sub_department || 'N/A'} • {emp.designation || 'N/A'}</p>
                        <p className="text-xs text-muted-foreground">
                          Reporting: {employeeNameById[emp.reporting_manager_id] || emp.reporting_manager_id || 'N/A'} • Work Anniversary: {getWorkAnniversaryLabel(emp.date_of_joining)}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 rounded-lg border border-border/60 bg-background p-1.5">
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => openEmployeeProfilePage(emp.employee_id)}
                        data-testid={`view-profile-${emp.employee_id}`}
                        className="h-8 w-8 p-0 hover:bg-primary/10 hover:text-primary transition-colors"
                        title="View profile"
                      >
                        <User className="h-3 w-3" />
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => openEmployeeEditPage(emp.employee_id)}
                        data-testid={`edit-employee-${emp.employee_id}`}
                        className="h-8 w-8 p-0 hover:bg-[hsl(var(--chart-4))]/10 hover:text-[hsl(var(--chart-4))] transition-colors"
                        title="Edit employee"
                      >
                        <Edit className="h-3 w-3" />
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleDeleteEmployee(emp.employee_id)}
                        data-testid={`delete-employee-${emp.employee_id}`}
                        className="h-8 w-8 p-0 hover:bg-destructive/10 hover:text-destructive transition-colors"
                        title="Deactivate employee"
                      >
                        <Trash className="h-3 w-3" />
                      </Button>
                      {emp.biometric_enrolled ? (
                        <span className="text-xs px-2 py-1 rounded-full bg-[hsl(var(--chart-2))]/10 text-[hsl(var(--chart-2))] font-medium">
                          Enrolled
                        </span>
                      ) : (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => {
                            setSelectedEmployee(emp);
                            setShowEnrollment(true);
                          }}
                          className="hover:bg-[hsl(var(--chart-5))]/10 hover:text-[hsl(var(--chart-5))] transition-colors"
                        >
                          <Fingerprint className="h-3 w-3 mr-1" />
                          Enroll
                        </Button>
                      )}
                    </div>
                  </div>
                ))}
                {filteredEmployees.length === 0 && (
                  <div className="text-center py-8 rounded-lg border border-dashed text-muted-foreground">
                    No employees found for current filters.
                  </div>
                )}
              </div>
            </CardContent>
          </Card>
        )}

        <Dialog open={showPerformerDetail} onOpenChange={setShowPerformerDetail}>
          <DialogContent size="xl">
            <DialogHeader className="pb-2">
              <DialogTitle>Employee Performance Detail</DialogTitle>
            </DialogHeader>
            {!selectedPerformerDetail ? (
              <p className="text-muted-foreground text-hr-sm">No data available.</p>
            ) : (
              <div className="space-y-4">
                <Card className="border-primary/15 bg-primary/5">
                  <CardContent className="pt-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-hr-lg font-semibold">{selectedPerformerDetail.employee?.employee_name}</p>
                        <p className="text-hr-xs text-muted-foreground">
                          {selectedPerformerDetail.employee?.employee_id} • {selectedPerformerDetail.employee?.department || 'N/A'} • {selectedPerformerDetail.employee?.designation || 'N/A'}
                        </p>
                      </div>
                      <Badge variant={selectedPerformerDetail.current?.overall_score >= 80 ? 'success' : selectedPerformerDetail.current?.overall_score >= 60 ? 'warning' : 'danger'}>
                        Overall {selectedPerformerDetail.current?.overall_score}
                      </Badge>
                    </div>
                  </CardContent>
                </Card>

                <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                  {(selectedPerformerDetail.current?.key_parameters || []).map((param) => (
                    <Card key={param.key}>
                      <CardContent className="pt-3">
                        <p className="text-hr-xs text-muted-foreground">{param.label}</p>
                        <p className="text-hr-lg font-bold">{param.score ?? 0}</p>
                      </CardContent>
                    </Card>
                  ))}
                </div>

                <Card className="border-primary/20">
                  <CardHeader className="pb-3">
                    <CardTitle className="text-hr-sm">Last 6-Month Trend</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="overflow-x-auto border rounded-md bg-background">
                      <table className="w-full text-hr-xs">
                        <thead>
                          <tr className="bg-muted/40 border-b">
                            <th className="p-2 text-left">Period</th>
                            <th className="p-2 text-left">Overall</th>
                            <th className="p-2 text-left">Goal</th>
                            <th className="p-2 text-left">Quality</th>
                            <th className="p-2 text-left">Time</th>
                            <th className="p-2 text-left">360</th>
                            <th className="p-2 text-left">Engagement</th>
                          </tr>
                        </thead>
                        <tbody>
                          {performerHistoryTable.data.map((h, i) => (
                            <tr key={`${h.year}-${h.month}-${i}`} className="border-b">
                              <td className="p-2">{String(h.month).padStart(2, '0')}/{h.year}</td>
                              <td className="p-2">{h.overall_score}</td>
                              <td className="p-2">{h.goal_achievement}</td>
                              <td className="p-2">{h.quality_score}</td>
                              <td className="p-2">{h.time_management_score}</td>
                              <td className="p-2">{h.feedback_360_score}</td>
                              <td className="p-2">{h.engagement_score}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="pt-3">
                      <TableControls
                        totalRows={performerHistoryTable.totalRows}
                        page={performerHistoryTable.page}
                        totalPages={performerHistoryTable.totalPages}
                        pageSize={performerHistoryTable.pageSize}
                        pageSizes={performerHistoryTable.pageSizes}
                        onPageSizeChange={performerHistoryTable.onPageSizeChange}
                        onPrevious={performerHistoryTable.goToPreviousPage}
                        onNext={performerHistoryTable.goToNextPage}
                      />
                    </div>
                  </CardContent>
                </Card>
              </div>
            )}
          </DialogContent>
        </Dialog>

        {!hasDedicatedAdminPage && resolveAdminTabComponent()}
        {!hasDedicatedAdminPage && activeTab === 'workspace' && (
          <div className="space-y-6">
            <div className="grid gap-6 lg:grid-cols-3">
              <Card className="lg:col-span-2">
                <CardHeader>
                  <CardTitle>Workspace Profile</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="grid gap-4 md:grid-cols-2">
                    <div>
                      <Label>Display Name</Label>
                      <Input
                        value={workspaceSettings.display_name}
                        onChange={(e) => setWorkspaceSettings({ ...workspaceSettings, display_name: e.target.value })}
                        placeholder="Acme HR"
                      />
                    </div>
                    <div>
                      <Label>Legal Name</Label>
                      <Input
                        value={workspaceSettings.legal_name}
                        onChange={(e) => setWorkspaceSettings({ ...workspaceSettings, legal_name: e.target.value })}
                        placeholder="Acme HR Private Limited"
                      />
                    </div>
                    <div>
                      <Label>Support Email</Label>
                      <Input
                        type="email"
                        value={workspaceSettings.support_email}
                        onChange={(e) => setWorkspaceSettings({ ...workspaceSettings, support_email: e.target.value })}
                        placeholder="support@example.com"
                      />
                    </div>
                    <div>
                      <Label>Support Phone</Label>
                      <Input
                        value={workspaceSettings.support_phone}
                        onChange={(e) => setWorkspaceSettings({ ...workspaceSettings, support_phone: e.target.value })}
                        placeholder="+91 98765 43210"
                      />
                    </div>
                    <div>
                      <Label>Website URL</Label>
                      <Input
                        value={workspaceSettings.website_url}
                        onChange={(e) => setWorkspaceSettings({ ...workspaceSettings, website_url: e.target.value })}
                        placeholder="https://example.com"
                      />
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <Label>Timezone</Label>
                        {/* A typed timezone that is not a real IANA zone is
                            accepted by the server and then breaks every shift
                            boundary and payroll cut-off that reads it. */}
                        <SelectField
                          value={workspaceSettings.timezone}
                          onChange={(next) => setWorkspaceSettings({ ...workspaceSettings, timezone: next })}
                          options={OPT.TIMEZONES}
                        />
                      </div>
                      <div>
                        <Label>Currency</Label>
                        <SelectField
                          value={workspaceSettings.currency_code}
                          onChange={(next) => setWorkspaceSettings({ ...workspaceSettings, currency_code: next })}
                          options={OPT.CURRENCIES}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <Label>Address</Label>
                    <Textarea
                      value={workspaceSettings.address}
                      onChange={(e) => setWorkspaceSettings({ ...workspaceSettings, address: e.target.value })}
                      placeholder="Registered office address"
                    />
                  </div>
                  <div>
                    <Label>Payslip Footer Note</Label>
                    <Textarea
                      value={workspaceSettings.payroll_note}
                      onChange={(e) => setWorkspaceSettings({ ...workspaceSettings, payroll_note: e.target.value })}
                      placeholder="Optional note to show in payroll exports or payslip context"
                    />
                  </div>
                  <div className="flex flex-wrap gap-3">
                    <Button onClick={() => handleSaveWorkspace(false)} disabled={workspaceLoading}>
                      Save Workspace
                    </Button>
                    <Button variant="outline" onClick={handleSeedWorkspaceDefaults} disabled={workspaceLoading}>
                      Seed Defaults
                    </Button>
                    <Button variant="secondary" onClick={() => handleSaveWorkspace(true)} disabled={workspaceLoading}>
                      Mark Setup Complete
                    </Button>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Setup Checklist</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <p className="text-hr-h2 font-bold">{workspaceSetup?.completion_percent ?? 0}%</p>
                    <p className="text-sm text-muted-foreground">
                      {workspaceSetup?.is_complete ? 'Workspace is marked complete' : 'Finish the checklist to complete setup'}
                    </p>
                  </div>
                  <div className="space-y-3">
                    {(workspaceSetup?.items || []).map((item) => (
                      <div key={item.key} className="rounded-lg border border-border p-3">
                        <div className="flex items-center justify-between gap-3">
                          <p className="font-medium">{item.label}</p>
                          <span className={`text-xs font-medium ${item.complete ? 'text-green-600' : 'text-amber-600'}`}>
                            {item.complete ? 'Done' : 'Pending'}
                          </span>
                        </div>
                        <p className="mt-1 text-sm text-muted-foreground">{item.detail}</p>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>

            <Card>
              <CardHeader>
                <CardTitle>Recent Audit Log</CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {auditLogs.length === 0 && (
                    <p className="text-sm text-muted-foreground">No audit events recorded yet for this workspace.</p>
                  )}
                  {auditLogs.map((event) => (
                    <div key={event.id} className="rounded-lg border border-border p-3">
                      <div className="flex flex-wrap items-center justify-between gap-2">
                        <div className="flex flex-wrap items-center gap-2">
                          <span className="font-medium">{event.action}</span>
                          <span className={`text-xs ${event.outcome === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                            {event.outcome}
                          </span>
                        </div>
                        <span className="text-xs text-muted-foreground">
                          {event.created_at ? new Date(event.created_at).toLocaleString() : ''}
                        </span>
                      </div>
                      <p className="mt-1 text-sm text-muted-foreground">
                        {event.actor_email} {event.target ? `• ${event.target}` : ''} {event.request_path ? `• ${event.request_path}` : ''}
                      </p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            <TenantOperatingModelPanel />
          </div>
        )}

          </>
        )}
      </div>

      {showEnrollment && selectedEmployee && (
        <CameraCapture
          title={`Enroll ${selectedEmployee.first_name} ${selectedEmployee.last_name}`}
          onCapture={handleBiometricEnrollment}
          onCancel={() => setShowEnrollment(false)}
        />
      )}
    </Layout>
  );
};

export default AdminDashboard;
